import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tw_reader_token";

export const readerToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const auth = () => ({ headers: { Authorization: `Bearer ${readerToken.get()}` } });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const readerApi = {
  register: async (payload) => (await axios.post(`${API}/reader/register`, payload)).data,
  login: async (email, password) => (await axios.post(`${API}/reader/login`, { email, password })).data,
  me: async () => (await axios.get(`${API}/reader/me`, auth())).data,
  logout: async () => {
    try { await axios.post(`${API}/reader/logout`, {}, auth()); } catch (e) { /* ignore */ }
    readerToken.clear();
  },
  forgot: async (email) => (await axios.post(`${API}/reader/forgot-password`, { email })).data,
  reset: async (token, password) => (await axios.post(`${API}/reader/reset-password`, { token, password })).data,
  getState: async () => (await axios.get(`${API}/reader/state`, auth())).data,
  saveLesson: async (key, patch) => (await axios.put(`${API}/reader/state/${key}`, patch, auth())).data,
  setLastLesson: async (index) => (await axios.put(`${API}/reader/last-lesson`, { index }, auth())).data,
  bookInfo: async () => (await axios.get(`${API}/reader/book/info`, auth())).data,
  reviewLink: async () => (await axios.get(`${API}/reader/review-link`, auth())).data,
  changePassword: async (password) => (await axios.post(`${API}/reader/change-password`, { password }, auth())).data,
  exportNotes: async () => (await axios.post(`${API}/reader/export-notes`, {}, auth())).data,
};
